import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "content", "nav"]

  connect() {
    this.updateActiveTab()
  }

  switchTab(event) {
    event.preventDefault()
    const clickedTab = event.currentTarget
    const tabName = clickedTab.dataset.tab

    this.setActiveTab(tabName)

  const url = clickedTab.getAttribute('href')
    if (url) {
      window.location.href = url
    }
  }

  setActiveTab(tabName) {
    this.tabTargets.forEach(tab => {
      tab.classList.remove('active')
      if (tab.dataset.tab === tabName) {
        tab.classList.add('active')
      }
    })
  }

  updateActiveTab() {
    const currentPath = window.location.pathname
    let activeTab = 'home'

    if (currentPath === '/dashboard' || currentPath === '/' || currentPath.startsWith('/dashboard')) {
      activeTab = 'home'
    } else if (currentPath.startsWith('/reservations') || currentPath.includes('reservation')) {
      activeTab = 'reservations'
    } else if (currentPath.startsWith('/records') || currentPath.startsWith('/training_records') || currentPath.startsWith('/body_measurements')) {
      activeTab = 'records'
    } else if (currentPath.startsWith('/payments') || currentPath.includes('plan') || currentPath.includes('ticket')) {
      activeTab = 'plans'
    } else if (currentPath.startsWith('/misc') || currentPath.startsWith('/profile')) {
      activeTab = 'misc'
    }

    this.setActiveTab(activeTab)
  }
}
